import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ActivityFeed, FilterBar, PageHeader, SectionCard } from '@striker/ui-shell';
import { apiFetch } from '../auth/session';

type AuditAction = {
  id: number;
  action: string;
  actor_sub: string | null;
  store_id?: number | null;
  created_at: string;
};

export function MasterAuditPage() {
  const [actions, setActions] = useState<AuditAction[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [storeIdFilter, setStoreIdFilter] = useState('');
  const [limit, setLimit] = useState(50);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const params = new URLSearchParams();
      params.set('limit', String(limit));
      if (storeIdFilter.trim()) params.set('storeId', storeIdFilter.trim());
      const res = await apiFetch(`/api/v1/master/audit?${params.toString()}`);
      if (!res.ok) throw new Error(`audit ${res.status}`);
      const body = (await res.json().catch(() => null)) as { actions?: AuditAction[] } | null;
      if (body?.actions) setActions(body.actions);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setLoading(false);
    }
  }, [limit, storeIdFilter]);

  useEffect(() => {
    void load();
  }, [load]);

  const items = actions.map((a) => ({
    id: a.id,
    action: a.action,
    actor: a.actor_sub,
    time: new Date(a.created_at).toLocaleString('it-IT'),
  }));

  return (
    <section className="sk-mc-page">
      <PageHeader
        title="Audit log"
        subtitle={
          <>
            <Link to="/master">← Master</Link> · log azioni master globali · {actions.length} eventi
          </>
        }
      />

      {error ? <p className="sk-error">{error}</p> : null}

      <FilterBar>
        <label className="sk-field">
          <span className="sk-saas-hint">Store ID</span>
          <input
            className="sk-input"
            type="number"
            placeholder="Tutti"
            value={storeIdFilter}
            onChange={(e) => setStoreIdFilter(e.target.value)}
            style={{ minWidth: '8rem' }}
          />
        </label>
        <label className="sk-field">
          <span className="sk-saas-hint">Limite</span>
          <select
            className="sk-input"
            value={limit}
            onChange={(e) => setLimit(Number(e.target.value))}
          >
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={200}>200</option>
          </select>
        </label>
        <button type="button" className="sk-btn sk-btn--quiet" onClick={() => void load()}>
          Aggiorna
        </button>
      </FilterBar>

      <SectionCard title="Eventi">
        {loading ? (
          <p className="sk-mc-hint">Caricamento…</p>
        ) : (
          <ActivityFeed items={items} />
        )}
      </SectionCard>
    </section>
  );
}
